export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const API_ENDPOINTS = {
  LAB_LOGIN: '/lab-login',
  VERIFY_LAB_TOKEN: '/verify-lab-token',
  VERIFY_PATIENT_TOKEN: '/verify-patient-token',
  PATIENT_SEND_OTP: '/patient-send-otp',
  PATIENT_VERIFY_OTP: '/patient-verify-otp',
  PATIENT_LIST: '/patients',
  PATIENTS_LIST: '/patients-list',
  PATIENT_CREATE: '/patients/add',
  PATIENT_SHOW_ID: '/patients/',
  PATIENT_UPDATE_ID: '/patients/',
  TEST_GROUPS: '/test-groups',
  TEST_GROUP_LIST: '/test-group-list',
  TESTS: '/tests',
  TEST_LIST: '/test-list',
  TEST_MATRIX: '/test-matrices',
  PATIENT_DIAGNOSE: '/patient-diagnose',
  PATIENT_DIAGNOSE_SAMPLE_NUMBER: '/patient-diagnose-sample-number',
  PATIENT_REPORTS: '/test-reports',
  TEST_REPORT_VIEW: '/view-test-reports',
  TEST_REPORT_DOWNLOAD: '/download-test-reports',
  TEST_REPORT_TESTS: '/test-reports-tests',
  SETTINGS: '/settings',
  SETTING_IMAGES: '/setting-images',
  GLOBAL_SETTINGS: '/global-settings',
  QUERIES: '/queries',
  BILLS: '/bills',
  BILL_PDF: '/generate-invoice-pdf',
  VIEW_INVOICE_PDF: '/view-invoice-pdf',
  DOWNLOAD_INVOICE_PDF: '/download-invoice-pdf',
  UPDATE_INVOICE_STATUS: '/update-invoice-status',

  // Lab endpoints
  LAB_STATISTICS: '/lab-statistics',
  LAB_YEARLY_STATISTICS: '/lab-yearly-statistics',
  LAB_COUNTRIES: '/lab/countries',
  LAB_STATES: '/lab/states',
  LAB_CITIES: '/lab/cities',
  LAB_PROFILE: '/lab-profile',

  // Patient endpoints
  MY_TESTS: '/patient/my-tests',
  MY_REPORTS: '/patient/my-reports',
  MY_PROFILE: '/patient/profile'
};